module.exports = __webpack_public_path__ + "img/background.6d9a06b0.png";